import React, { useEffect, useState } from 'react'
import { Icon } from "@iconify/react";
import '../../Assets/CSS/ExitInterviewQuestion.css'
import axios from 'axios';
import toast from 'react-hot-toast';

const ExitInterviewQuestion = () => {
    const [question, setQuestion] = useState("");
    const [questionsList, setQuestionsList] = useState([]);
    const [error, setError] = useState("");


    // 🔹 GET API – Fetch questions on load
    const token = localStorage.getItem("token");
    useEffect(() => {
        fetchQuestions();
    }, []);

    const fetchQuestions = async () => {
        try {
            const res = await axios.get(
                `${process.env.REACT_APP_BACKEND_URL}/api/v1/offboarding/configuration/questions`,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );

            setQuestionsList(res.data);


        } catch (err) {
            console.error("Error fetching questions:", err);
        }
    };

    // 🔹 POST API – Add new question
    const handleAdd = async () => {
        if (question.trim() === "") {
            setError("Question is required");
            return;
        }

        try {
            await axios.post(
                `${process.env.REACT_APP_BACKEND_URL}/api/v1/offboarding/configuration/questions`,
                { question },
                {
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${token}`,
                    },
                }
            );

            toast.success("Exit Interview Question Added");

            // ✅ Fetch fresh backend data
            await fetchQuestions();

            setQuestion("");
            setError("");

        } catch (err) {
            console.error("Error adding question:", err);

            toast.error("Exit Interview Question Not Added");
        }
    };




    const handleDelete = async (index) => {
        const questionId = questionsList[index].questionId;

        try {
            await axios.delete(
                `${process.env.REACT_APP_BACKEND_URL}/api/v1/offboarding/configuration/questions/${questionId}`,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );

            toast.success("Deleted Exit Interview Question successfully");

            // ✅ Refresh from backend
            await fetchQuestions();

        } catch (error) {
            toast.error("Not Delete Exit Interview Question");

            console.error("Error deleting question:", error);
        }
    };


    const questions = {
        fontFamily: 'Inter, sans-serif',
        fontWeight: 500,
        fontSize: '14px',
        color: '#303030'
    };
    const heading = {
        fontFamily: 'Inter, sans-serif',
        fontWeight: 400,
        fontSize: '12px',
        color: '#303030'
    };

    return (
        <div className="">
            <p style={{ ...heading }}>Define questions that will be asked during the exit interview process.</p>

            {/* Add Question Box */}
            <div className=" p-3  p-md-1" style={{ backgroundColor: '#F6F6F6', borderRadius: '10px' }}>
                <p className="fs fw-semibold" style={{ ...questions, fontWeight: 'bold' }}>Add New Question</p>

                <div className="mb-3">
                    <input
                        type="text"
                        className="form-control"
                        placeholder="Enter question"
                        value={question}
                        onChange={(e) => {
                            setQuestion(e.target.value);
                            if (error) setError("");
                        }}
                        style={{
                            borderRadius: "8px",
                            border: "1px solid #C8C8C8",
                            backgroundColor: "#F4F4F4",
                            color: "#606060",
                        }}
                    />
                    {error && (
                        <p style={{ color: "red", fontSize: "12px", marginTop: "4px" }}>
                            {error}
                        </p>
                    )}
                </div>

                <button
                    onClick={handleAdd}
                    className="add-btn d-flex align-items-center justify-content-center"
                    style={{
                        width: "140px",
                        height: "40px",
                        fontSize: "14px",
                        marginTop: "25px",
                        gap: "6px"
                    }}
                >
                    <Icon icon="material-symbols:add-rounded" width="18" />
                    Add
                </button>
            </div>

            {/* Created Questions */}
            <div className="mt-4">

                {questionsList.length > 0 && <p style={{ ...questions, fontSize: "16px" }}>Created Questions</p>}

                {/* {questionsList.map((q, index) => ( */}
                {questionsList.map((q, index) => (
                    <div
                        key={index}
                        className="question-item d-flex justify-content-between align-items-start mb-3 "
                    >
                        {/* Question text */}
                        {/* <span className="question-text" style={{...questions}}>
                            {index + 1}. {q}
                        </span> */}
                        <span className="question-text" style={{ ...questions }}>
                            {index + 1}. {q.question}
                        </span>


                        {/* Delete icon */}
                        <Icon
                            icon="material-symbols:delete-outline"
                            width="22"
                            className="delete-icon"
                            onClick={() => handleDelete(index)}
                        />
                    </div>
                ))}
            </div>
        </div>
    );
}

export default ExitInterviewQuestion;